module.exports = __webpack_public_path__ + "img/milestone__2001.7c384c9c.jpg";